import { Component, OnInit, Inject } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { HDService } from '../../services/hd.service';
import { UserService } from '../../services/user.service';
import { Methods } from '../../shared/methods';

declare interface DialogData {
  manufacturer: string;
  model: string;
  serial_number: string;
  results: string;
  serial_number_new: string;
  po: string;
}

@Component({
  selector: 'app-manualityadd',
  templateUrl: './manualityadd.component.html',
  styleUrls: ['./manualityadd.component.css'],
  providers: [ HDService ]
})
export class ManualityaddComponent implements OnInit {

  public saving = false;
  public identity;
  public token;
  public apiCompany;

  public mtds: Methods = new Methods();

  constructor(
    public dialogRef: MatDialogRef<ManualityaddComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private _hdService: HDService,
    private _userService: UserService
  ) {
    this.identity = JSON.parse(localStorage.getItem("identity"));
    this.token = JSON.parse(localStorage.getItem("token"));

    this._userService.getUser(this.token, this.identity.sub).subscribe(
      r => {
        this.apiCompany = r.data.companyLinked.apiToken;
      }
    );
  }

  ngOnInit() {
  }

  onNoClick() {
    this.saving = true;
    this._hdService.addManuality(this.data, this.apiCompany).subscribe(
      (r: any) => {
        console.log(r);
        if (r.status === 'success') {
          this.mtds.notifySuccess(r.msg);
          this.dialogRef.close();
        } else {
          this.mtds.notifyError(r.msg);
        }
        this.saving = false;
      }, (error) => {
        this.saving = false;
        this.mtds.notifyError('Something went wrong');
      }
    );
  }

}
